module.exports = __webpack_public_path__ + "img/success-icon.7347cd0e.png";